import { TranslateContext } from "./TranslateContext"
import { useCallback, useMemo } from "react";
import PropTypes from "prop-types";
import { IS_DEV } from "../../utils";

function flatObject(obj, prefix = "") {
    return Object.entries(obj).reduce((acc, [key, value]) => {
        if (typeof value === 'object') {
            return {
                ...acc,
                ...flatObject(value, `${prefix}${key}.`)
            }
        }
        return {
            ...acc,
            [`${prefix}${key}`]: value
        }
    }, {})
}

export function TranslateProvider({ children, texts }) {
    const flatTexts = useMemo(() => flatObject(texts), [texts])


    const translate = useCallback((text, params = {}) => {
        let matchText = flatTexts[text]

        if (!matchText && IS_DEV) {
            console.warn(`Text ${text} not found`)
            return text
        }

        for (const param in params) {
            const key = `%${param}%`;
            const value = params[param];
            matchText = matchText.replaceAll(key, value)
        }
        return matchText ?? ""
    }, [flatTexts])

    return (
        <TranslateContext.Provider value={translate}>
            {children}
        </TranslateContext.Provider>
    )
}

TranslateProvider.propTypes = {
    children: PropTypes.node,
    texts: PropTypes.object
}